import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const OptionalAnchor = /*#__PURE__*/React.forwardRef(function OptionalAnchor(props, ref) {
  if (props.href) {
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
      rel: "noopener"
    }, props), {}, {
      ref: ref
    }));
  }
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});